"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeEval = safeEval;
exports.toPrecision = toPrecision;
const context = {
    toPrecision
};
function safeEval(template) {
    const fn = new Function("context", `"use strict";
        const { toPrecision } = context;
        return ${template};`);
    return fn(context);
}
function toPrecision(value, precision) {
    return parseFloat(value.toFixed(precision));
}
